import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import ExerciseCard from "../../../components/ExerciseCard";
import HorizontalScrollBar from "../../../components/HorizontalScrollBar";

const SimilarExercises = ({ targetMuscleExercises, equipmentExercises }) => {
  return (
    <Box mt="100px" mb="100px" ml="15px">
      {targetMuscleExercises?.length > 0 ? (
        <Stack sx={{ position: "relative", width: "100%" }}>
          <Typography mb="30px" variant="h4" fontWeight="bold">
            Similar <span style={{ color: "#ff2625" }}>Target Muscle</span>{" "}
            exercises
          </Typography>
          <HorizontalScrollBar>
            {targetMuscleExercises.map((exercise) => (
              <Box key={exercise?.name} mr="40px">
                <ExerciseCard exercise={exercise} />
              </Box>
            ))}
          </HorizontalScrollBar>
        </Stack>
      ) : undefined}

      {equipmentExercises?.length > 0 ? (
        <Stack sx={{ position: "relative", width: "100%"}}>
          <Typography mb="30px" variant="h4" fontWeight="bold">
            Similar <span style={{ color: "#ff2625" }}>Equipment</span>{" "}
            exercises
          </Typography>
          <HorizontalScrollBar>
            {equipmentExercises.map((exercise) => (
              <Box key={exercise?.name} mr="40px">
                <ExerciseCard exercise={exercise} />
              </Box>
            ))}
          </HorizontalScrollBar>
        </Stack>
      ) : undefined}
    </Box>
  );
};

export default SimilarExercises;
